<template>
    <header style="background-image: url(https://bible-esv-140cb.firebaseapp.com/bodybg3.png);">
        <div class="container">
            <div class="row banner">
                <div class="col-9 bannerchild flex-container">
                    <ul><router-link to="/" tag="li" exact><a><h1>My Bible <span>(ESV and KJV)</span></h1></a></router-link></ul>
                </div>
                <div class="col-3 bannerchild">
                    <img src="https://bible-esv-140cb.firebaseapp.com/jesus-line-art-small.png" />
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <nav class="navbar navbar-expand-lg navbar-dark">
                        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                            <span class="navbar-toggler-icon"></span>
                        </button>

                        <div class="collapse navbar-collapse" id="navbarSupportedContent">
                            <ul class="navbar-nav mr-auto">
                                <router-link to="/favourites" tag="li" active-class="active"><a class="default">Favourites</a></router-link>
                                <router-link to="/jesus" tag="li" active-class="active"><a class="default">Jesus</a></router-link>
                                <router-link v-if="!this.$store.getters.getLoggedInState" to="/auth" tag="li"><a class="login">Login</a></router-link>
                                <button v-else class="btn btn-info logout" @click="logOut">Logout</button>
                            </ul>
                        </div>
                    </nav>
                </div>
            </div>
        </div>
    </header>
</template>

<script>
    export default {
        methods: {
            logOut() {
                auth.signOut().then(res => {
                    this.$store.dispatch('setLoggedIn',false);
                }).catch(function(error) {
                    console.log("Error: ", error);
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/TheHeader.vue